<template>
    <div class="search-layout">
        <div class="search-layout__top">
            <div class="container container_size_small">
                <div class="search-layout__row">
                    <h1 class="title search-layout__title">{{ t('search.title') }}</h1>
                    <svg class="icon icon_size_l search-layout__back" @click="back">
                        <use xlink:href="/img/sprites/icons-sprite.svg#icon-close"></use>
                    </svg>
                </div>
                <GlobalSearch :params="{class: 'global-search_large'}"/>
            </div>
        </div>
        <div class="container container_size_small">
            <slot/>
        </div>
    </div>
</template>

<script>
import GlobalSearch from '@/components/UI/globalSearch/index.vue'
import {useI18n} from "vue-i18n";
import {useRouter} from "vue-router";
import {useStore} from "vuex";

export default {
    name: 'searchLayout',
    components: {
        GlobalSearch,
    },
    setup() {
        const {t} = useI18n()
        const router = useRouter()
        const back = () => {
            router.go(-1)
        }
        return {
            t,
            back
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/layouts/search-layout.scss';
</style>

